import { useEffect, useState } from "react";
import { Link } from "react-router";
import useSendPulseGaData from "@features/pulse/hooks/useSendPulseGaData";
import { ENDING_SCREEN_CONTENT } from "@features/pulse/utils/constants";
import { cn } from "@util/helpers";

type PulseEndingScreenProps = {
  /** Random number to select a message and emoji from the list */
  randomNumber: number;
};

/** Pulse ending screen for pulse
 * displays a random message and emoji from a list of 12 */
const PulseEndingScreen = ({
  randomNumber,
}: PulseEndingScreenProps): React.ReactElement => {
  const { sendCustomEvent } = useSendPulseGaData();
  const [backToBt, setBackToBt] = useState<string>("");

  useEffect(() => {
    const path = sessionStorage.getItem("pulse_back_path") || "/";
    setBackToBt(path);
  }, []);

  const content = ENDING_SCREEN_CONTENT[randomNumber];

  const handleCloseSendData = () => {
    sendCustomEvent("outro", "close");
  };

  return (
    <div className="flex flex-grow flex-col items-center justify-center px-4 py-6 text-center font-poppins text-white">
      <div className="flex flex-grow flex-col items-center justify-center md:flex-grow-0">
        <p className="mb-3 text-10xl">{content.emoji}</p>
        {content.text.map((line, index) => (
          <p
            key={index}
            className="mb-0 text-lg font-medium leading-normal tracking-2% lg:text-4xl"
          >
            {line}
          </p>
        ))}
      </div>

      <Link
        to={`${backToBt}?ref=pulse`}
        reloadDocument
        className={cn(
          "mask-gradient relative mt-8 rounded-full bg-white/10",
          "text-xs font-semibold leading-normal tracking-2%",
          "w-full min-w-full py-6 text-white md:min-w-[320px] md:max-w-[320px] md:px-6",
          "before:absolute before:inset-0 before:rounded-full before:bg-pulseButton before:p-[2px]",
          "before:hover:animate-pulseGradientAnimation"
        )}
        onClick={handleCloseSendData}
      >
        <p>Close</p>
      </Link>
    </div>
  );
};

export default PulseEndingScreen;
